import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "tw-flex tw-relative tw-justify-between tw-gap-6" };
const _hoisted_3 = { class: "tw-flex tw-items-center sm:tw-gap-3 tw-gap-2" };
const _hoisted_4 = { class: "main-container-cat tw-w-full" };
const _hoisted_5 = {
    key: 0,
    class: "md:tw-relative md:tw-w-[70%] tw-max-h-[calc(100vh-180px)] tw-h-[calc(100vh-180px)] tw-w-[90%] tw-absolute sm:tw-right-unset tw-right-0 sm:tw-left-unset tw-left-0 tw-mx-auto sm:tw-top-0 tw-top-[0px]"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CasinoLiveHeader = _resolveComponent("CasinoLiveHeader");
    const _component_CasinoLiveComponentSidebar = _resolveComponent("CasinoLiveComponentSidebar");
    const _component_CardTitle = _resolveComponent("CardTitle");
    const _component_CardContent = _resolveComponent("CardContent");
    const _component_Card = _resolveComponent("Card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: _normalizeClass([
                    $setup.gameUrl
                        ? 'tw-w-full'
                        : 'min-[992px]:tw-w-[calc(100%-380px)] tw-w-full',
                    "tw-max-w-screen-2xl sm:tw-mt-0 tw-mt-5"
                ])
            }, [
                _createVNode(_component_CasinoLiveHeader, {
                    games: $props.games,
                    isLoading: $props.isLoading
                }, null, 8, ["games", "isLoading"]),
                _createElementVNode("div", {
                    class: _normalizeClass([$setup.gameUrl ? 'tw-block ' : 'min-[992px]:tw-hidden tw-block', "min-[992px]:tw-w-[70%] tw-w-full input-categories"])
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: `https://azurecoinz.com/img/sq-arrow-left.svg`,
                            alt: "Previous",
                            class: "sm:tw-w-[44px] tw-w-5 tw-h-5 sm:tw-h-[45px] tw-mt-[22px] left-arrow"
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_CasinoLiveComponentSidebar, { liveGameCategories: $props.liveGameCategories }, null, 8, ["liveGameCategories"])
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("img", {
                            src: `https://azurecoinz.com/img/sq-arrow-right.svg`,
                            alt: "Next",
                            class: "sm:tw-w-[44px] tw-w-5 tw-h-5 sm:tw-h-[45px] tw-mt-[22px]"
                        }, null, -1))
                    ])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass([$setup.gameUrl ? 'tw-flex tw-w-full tw-gap-6' : 'tw-w-full', "mt-4"])
                }, [
                    ($setup.gameUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("button", {
                                class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => ($setup.closeGame && $setup.closeGame(...args)))
                            }, " Close "),
                            _createElementVNode("iframe", {
                                src: $setup.gameUrl,
                                frameborder: "0",
                                class: "tw-w-full tw-h-full"
                            }, null, 8, _hoisted_6)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass($setup.gameUrl ? 'md:tw-w-[30%] tw-w-full' : 'tw-w-full')
                    }, [
                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_CardTitle, {
                                    class: _normalizeClass([$setup.gameUrl ? 'tw-block' : 'tw-hidden', "tw-mb-4 tw-text-lg"])
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($props.selectedLiveCategory?.name || "All"), 1)
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                ($props.games.length)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        ref: "scrollContainer",
                                        class: _normalizeClass([
                                            $setup.gameUrl
                                                ? 'tw-max-h-[calc(100vh-214px)]'
                                                : 'tw-max-h-[calc(100vh-180px)]',
                                            "tw-overflow-auto"
                                        ])
                                    }, [
                                        _createVNode(_component_CardContent, {
                                            class: _normalizeClass($setup.gameUrl
                                                ? 'scroller tw-grid tw-grid-cols-3  md:tw-grid-cols-2  lg:tw-grid-cols-2 tw-gap-4'
                                                : 'scroller tw-grid tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4 tw-bg-[#140736]')
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.games, (game) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: game.id
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "tw-flex tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                            onClick: ($event) => ($setup.handleGameClick(game))
                                                        }, [
                                                            _createElementVNode("img", {
                                                                src: game.gameIcon
                                                                    ? game.gameIcon
                                                                    : 'https://contents.static-slotcity.com/game_pic/bng/197.png',
                                                                alt: game.name,
                                                                class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                            }, null, 8, _hoisted_8)
                                                        ], 8, _hoisted_7)
                                                    ]));
                                                }), 128))
                                            ]),
                                            _: 1
                                        }, 8, ["class"]),
                                        ($props.isLoading)
                                            ? (_openBlock(), _createBlock(_component_CardContent, {
                                                key: 0,
                                                class: _normalizeClass($setup.gameUrl
                                                    ? 'tw-mt-6 tw-grid tw-grid-cols-3 sm:tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4'
                                                    : 'tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6')
                                            }, {
                                                default: _withCtx(() => [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                        return _createElementVNode("div", {
                                                            key: 'skeleton-' + index,
                                                            class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                        }, _cache[3] || (_cache[3] = [
                                                            _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                        ]));
                                                    }), 64))
                                                ]),
                                                _: 1
                                            }, 8, ["class"]))
                                            : _createCommentVNode("", true)
                                    ], 2))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ], 2)
                ], 2)
            ], 2),
            _createElementVNode("div", {
                class: _normalizeClass($setup.gameUrl ? 'tw-hidden' : 'max-[992px]:tw-hidden tw-block')
            }, [
                _createVNode(_component_CasinoLiveComponentSidebar, { liveGameCategories: $props.liveGameCategories }, null, 8, ["liveGameCategories"])
            ], 2)
        ])
    ]));
}
